$(document).ready(function(){

    //DatePicker function
    $( "#datepicker" ).datepicker();
    
    //AutocompleteScript
    var availableTags = [
      "ActionScript",
      "AppleScript",
      "Asp",
      "BASIC",
      "C",
      "C++",
      "Clojure",
      "COBOL",
      "ColdFusion",
      "Erlang",
      "Fortran",
      "Groovy",
      "Haskell",
      "Java",
      "JavaScript",
      "Lisp",
      "Perl",
      "PHP",
      "Python",
      "Ruby",
      "Scala",
      "Scheme"
    ];
    $( "#autocompleteInput" ).autocomplete({
      source: availableTags
    });
    
    //slider script
    $( "#slider" ).slider();
    
});
